import type { Creator } from '../types/catalog';
import { images } from './images';

export const creators: Creator[] = [
  {
    id: 'maison-ocre',
    name: 'Maison Ocre',
    maker: 'Léa Marchand',
    craft: 'Bijoux en laiton et argile',
    category: 'bijoux',
    city: 'Lyon',
    bio: 'Léa martèle le laiton dans un petit atelier des pentes de la Croix-Rousse et y associe des pastilles d’argile qu’elle cuit elle-même. Chaque paire porte la trace de l’outil.',
    quote: 'J’aime que le bijou garde la mémoire du geste.',
    exhibitionStart: '2026-08-01',
    exhibitionEnd: '2026-10-31',
    permanenceDays: ['Samedi'],
    image: images.earrings,
  },
  {
    id: 'perle-de-rive',
    name: 'Perle de Rive',
    maker: 'Inès Fabre',
    craft: 'Colliers de perles d’eau douce',
    category: 'bijoux',
    city: 'Marseille',
    bio: 'Ancienne restauratrice de textiles anciens, Inès enfile des perles baroques sur soie et compose des colliers aux formes jamais tout à fait régulières.',
    quote: 'Une perle irrégulière a plus de choses à raconter.',
    exhibitionStart: '2026-09-01',
    exhibitionEnd: '2026-11-30',
    permanenceDays: ['Samedi'],
    image: images.necklace,
  },
  {
    id: 'atelier-sillon',
    name: 'Atelier Sillon',
    maker: 'Hugo Benoît',
    craft: 'Grès tourné et émaillé',
    category: 'deco',
    city: 'Dieulefit',
    bio: 'Hugo tourne des pièces utilitaires en grès, cuites à haute température. Ses émaux sont préparés à partir de cendres et de terres locales.',
    quote: 'Un bol doit d’abord être agréable à tenir.',
    exhibitionStart: '2026-09-15',
    exhibitionEnd: '2026-12-14',
    permanenceDays: ['Samedi', 'Mardi'],
    image: images.workshop,
  },
  {
    id: 'lin-et-lame',
    name: 'Lin & Lame',
    maker: 'Camille Roux',
    craft: 'Sacs en lin et cuir',
    category: 'mode',
    city: 'Nantes',
    bio: 'Camille coupe et coud des cabas en lin lavé, renforcés de cuir cognac. Des sacs simples, solides, pensés pour le marché comme pour la ville.',
    quote: 'Je dessine des sacs qu’on oublie à force de les porter.',
    exhibitionStart: '2026-07-20',
    exhibitionEnd: '2026-10-19',
    permanenceDays: ['Mardi'],
    image: images.bag,
  },
  {
    id: 'bois-de-coeur',
    name: 'Bois de Cœur',
    maker: 'Antoine Lemaire',
    craft: 'Tournage sur bois',
    category: 'deco',
    city: 'Jura',
    bio: 'Antoine travaille les essences locales — noyer, merisier, frêne — tombées ou issues d’élagage. Chaque bol suit le fil du bois.',
    quote: 'Le bois décide souvent de la forme.',
    exhibitionStart: '2026-08-15',
    exhibitionEnd: '2026-11-14',
    permanenceDays: ['Samedi'],
    image: images.bowl,
  },
  {
    id: 'savonnerie-des-pres',
    name: 'Savonnerie des Prés',
    maker: 'Julie Martin',
    craft: 'Savons saponifiés à froid',
    category: 'local',
    city: 'Gironde',
    bio: 'Julie fabrique ses savons en petites séries avec des huiles bio, des argiles et des plantes cueillies autour de chez elle. Cure de six semaines minimum.',
    quote: 'Le temps de cure, c’est le secret qu’on ne peut pas presser.',
    exhibitionStart: '2026-09-01',
    exhibitionEnd: '2026-11-30',
    permanenceDays: ['Mercredi'],
    image: images.soap,
  },
  {
    id: 'rucher-du-vallon',
    name: 'Rucher du Vallon',
    maker: 'Pierre & Anne Gauthier',
    craft: 'Apiculteurs',
    category: 'local',
    city: 'Entre-deux-Mers',
    bio: 'Une soixantaine de ruches installées entre vignes et prairies. Pierre et Anne récoltent à la main et mettent en pot sans chauffer le miel.',
    quote: 'Chaque récolte a le goût de sa saison.',
    exhibitionStart: '2026-10-01',
    exhibitionEnd: '2026-12-31',
    permanenceDays: ['Vendredi'],
    image: images.honey,
  },
  {
    id: 'feutre-et-forme',
    name: 'Feutre & Forme',
    maker: 'Margaux Petit',
    craft: 'Chapelière',
    category: 'mode',
    city: 'Toulouse',
    bio: 'Formée chez un chapelier toulousain, Margaux met en forme le feutre de laine à la vapeur, sur des formes en bois anciennes.',
    quote: 'Un chapeau se règle comme un instrument.',
    exhibitionStart: '2026-09-10',
    exhibitionEnd: '2026-12-09',
    permanenceDays: ['Mercredi'],
    image: images.hat,
  },
  {
    id: 'terre-de-lune',
    name: 'Terre de Lune',
    maker: 'Sofia Mendes',
    craft: 'Luminaires en céramique',
    category: 'deco',
    city: 'Bordeaux',
    bio: 'Sofia façonne des pieds de lampe en faïence et les habille d’abat-jours plissés en lin, cousus main.',
    quote: 'Je cherche une lumière qui ressemble à la fin d’après-midi.',
    exhibitionStart: '2026-08-20',
    exhibitionEnd: '2026-11-19',
    permanenceDays: ['Jeudi'],
    image: images.lamp,
  },
  {
    id: 'herbier-noir',
    name: 'Herbier Noir',
    maker: 'Clément Durand',
    craft: 'Illustrateur botaniste',
    category: 'deco',
    city: 'Arcachon',
    bio: 'Clément dessine à l’encre et à l’aquarelle les herbes sauvages du littoral. Ses tirages sont numérotés et signés.',
    quote: 'Dessiner une plante, c’est apprendre à la regarder.',
    exhibitionStart: '2026-09-05',
    exhibitionEnd: '2026-12-04',
    permanenceDays: ['Mardi'],
    image: images.print,
  },
  {
    id: 'cuir-sauvage',
    name: 'Cuir Sauvage',
    maker: 'Yanis Haddad',
    craft: 'Maroquinier',
    category: 'mode',
    city: 'Périgueux',
    bio: 'Yanis travaille un cuir tanné végétal, coupé et cousu au point sellier. Des petites pièces qui se patinent au fil des années.',
    quote: 'Un bon cuir est plus beau dans dix ans.',
    exhibitionStart: '2026-07-25',
    exhibitionEnd: '2026-10-24',
    permanenceDays: ['Jeudi'],
    image: images.wallet,
  },
  {
    id: 'argent-brut',
    name: 'Argent Brut',
    maker: 'Nora Lefèvre',
    craft: 'Bijoux en argent recyclé',
    category: 'bijoux',
    city: 'Bayonne',
    bio: 'Nora fond de l’argent recyclé et sertit des pierres brutes, choisies une à une. Bagues ajustées à la taille sur demande.',
    quote: 'Je laisse la pierre telle qu’on l’a trouvée.',
    exhibitionStart: '2026-09-20',
    exhibitionEnd: '2026-12-19',
    permanenceDays: ['Vendredi'],
    image: images.ring,
  },
  {
    id: 'cire-et-flamme',
    name: 'Cire & Flamme',
    maker: 'Élise Bonnet',
    craft: 'Bougies en cire végétale',
    category: 'deco',
    city: 'Libourne',
    bio: 'Élise coule ses bougies dans des pots en céramique tournés par une amie potière. Parfums naturels, mèches en coton.',
    quote: 'Une bougie, c’est une heure que l’on s’accorde.',
    exhibitionStart: '2026-08-10',
    exhibitionEnd: '2026-11-09',
    permanenceDays: ['Mercredi'],
    image: images.candle,
  },
  {
    id: 'fil-indigo',
    name: 'Fil Indigo',
    maker: 'Thomas Girard',
    craft: 'Vêtements teints aux plantes',
    category: 'mode',
    city: 'Angoulême',
    bio: 'Thomas coud des chemises et vestes en lin, teintes à la garance, à l’indigo ou au pastel. Chaque bain donne une nuance unique.',
    quote: 'Les plantes ne donnent jamais deux fois la même couleur.',
    exhibitionStart: '2026-10-01',
    exhibitionEnd: '2026-12-31',
    permanenceDays: ['Samedi'],
    image: images.catTextile,
  },
  {
    id: 'la-fabrique-sucree',
    name: 'La Fabrique Sucrée',
    maker: 'Aurélie Blanc',
    craft: 'Confitures et douceurs',
    category: 'local',
    city: 'Lot-et-Garonne',
    bio: 'Confitures cuites au chaudron, pâtes de fruits et biscuits avec les fruits des vergers voisins. Peu de sucre, beaucoup de fruit.',
    quote: 'Je cuisine les fruits comme ils arrivent.',
    exhibitionStart: '2026-10-01',
    exhibitionEnd: '2026-12-31',
    permanenceDays: ['Vendredi'],
    image: images.catLocal,
  },
  {
    id: 'verre-souffle',
    name: 'Souffle Clair',
    maker: 'Lucie Moreau',
    craft: 'Verre soufflé',
    category: 'deco',
    city: 'Biot',
    bio: 'Lucie souffle des carafes, verres et vases teintés dans la masse, aux bulles volontairement visibles.',
    quote: 'Le verre garde la trace du souffle.',
    exhibitionStart: '2026-10-20',
    exhibitionEnd: '2027-01-19',
    permanenceDays: ['Jeudi'],
    image: images.catDeco,
  },
  {
    id: 'tisserande-du-nord',
    name: 'Trame du Nord',
    maker: 'Manon Leroy',
    craft: 'Tissage sur métier',
    category: 'mode',
    city: 'Roubaix',
    bio: 'Plaids, écharpes et coussins tissés sur un métier à bras, en laine et lin de filatures françaises.',
    quote: 'Tisser, c’est compter et rêver en même temps.',
    exhibitionStart: '2026-11-01',
    exhibitionEnd: '2027-01-31',
    permanenceDays: ['Mardi'],
    image: images.catTextile,
  },
  {
    id: 'papier-plume',
    name: 'Papier Plume',
    maker: 'Jeanne Caron',
    craft: 'Papeterie et reliure',
    category: 'deco',
    city: 'Angers',
    bio: 'Carnets cousus main, papiers marbrés et cartes imprimées en typographie au plomb.',
    quote: 'Un carnet vide est déjà une promesse.',
    exhibitionStart: '2026-11-15',
    exhibitionEnd: '2027-02-14',
    permanenceDays: ['Mercredi'],
    image: images.print,
  },
  {
    id: 'la-main-verte',
    name: 'La Main Verte',
    maker: 'Paul Simon',
    craft: 'Kokedamas et plantes',
    category: 'deco',
    city: 'Bordeaux',
    bio: 'Paul compose des kokedamas et terrariums avec des plantes de petits producteurs girondins.',
    quote: 'Une plante bien placée change une pièce.',
    exhibitionStart: '2026-06-01',
    exhibitionEnd: '2026-08-31',
    permanenceDays: ['Samedi'],
    image: images.hero,
  },
  {
    id: 'email-et-cie',
    name: 'Émail & Cie',
    maker: 'Chloé Vidal',
    craft: 'Bijoux émaillés',
    category: 'bijoux',
    city: 'Limoges',
    bio: 'Chloé perpétue l’émail sur cuivre de Limoges avec des broches et pendentifs aux couleurs franches.',
    quote: 'L’émail, c’est de la couleur cuite au feu.',
    exhibitionStart: '2026-06-15',
    exhibitionEnd: '2026-09-15',
    permanenceDays: ['Jeudi'],
    image: images.catBijoux,
  },
];
